module.exports = __webpack_public_path__ + "img/sync360.870c660d.png";